import { render, staticRenderFns } from "./CustomersPopup.vue?vue&type=template&id=03c6991a&"
import script from "./CustomersPopup.vue?vue&type=script&lang=js&"
export * from "./CustomersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports